<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    title="行车轨迹"
    width="80%"
  >
    <div id="mapContainer" style="height:500px;"/>
    <div slot="footer" class="dialog-footer" style="text-align:center;height:30px;line-height: 30px;">
      <div style="float:left;display:flex;align-items:center;">
        <img src="@/assets/img/emp_makers.png" style="width:25px;height:25px;"/> 员工签到
        <img src="@/assets/img/driver_makers.png" style="width:25px;height:25px;margin-left:20px;"/> 司机签到
      </div>
      <el-button size="mini" @click="closeForm" style="float:right">取消</el-button>
    </div>
  </el-dialog>
</template>
<script>
// 导入组件
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getClockList } from  "@/api/order/orderinfo"
export default {
  components: {
      ElImageViewer
  },
  computed: {
  },
  data() {
    return {
      visible: false,
      loading: false,
      rowInfo: {},
      clockInfos:[],//打卡信息
      passingPlaces:[], //途径点信息
      showViewer: false, // 显示查看器
      map:null,
      marker: null,
      center: null,
      paths:[], // 途径所有点坐标
      pointStyles:{
          // // 小车样式
          // 'car-down': new TMap.MarkerStyle({
          //   'width': 40,
          //   'height': 40,
          //   'anchor': {x: 20,y: 20,},
          //   'faceTo': 'map',
          //   'rotate': 360,
          //   'src': require('@/assets/img/car.png'),
          // }),
          // 起点样式
          "start": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 12, y: 32 },
            "src": require('@/assets/img/start.png'),
          }),
          // 终点样式
          "end": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 30, y: 32 },
            "src": require('@/assets/img/end.png')
          }),
          // 途径点样式
          "passingPlace": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 16, y: 32 },
            "src": require('@/assets/img/tujing_makers.png')
          }),
          // 员工打卡点样式
          "empClock": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 16, y: 32 },
            "src": require('@/assets/img/emp_makers.png')
          }),
          // 司机打卡点样式
          "driverClock": new TMap.MarkerStyle({
            "width": 25,
            "height": 35,
            "anchor": { x: 16, y: 32 },
            "src": require('@/assets/img/driver_makers.png')
          })
        },
        geometries:[],
        clockType: {
          EMP: 1, // 员工
          DRIVER: 2, // 司机
        },
        pointFlag:{
          car: "CAR",
          start: "START",
          clock: "CLOCK",
          pass: "PASS",
          end: "END"
        },
        innerVisible:false,
    }
  },

  methods: {
    init(obj) {
      this.visible = true;
      this.rowInfo = obj;
      let that = this;
      if (this.rowInfo){
        // 途径点信息赋值
        this.passingPlaces = this.rowInfo.passingPlaceList;
        this.getClockList();//加载打卡地址
      }else{
        setTimeout(function() {
            that.getMyLocation();
        },1000)
      }
    },
    /**
     * 查询打卡地点
     */
    getClockList(){
        let that = this;
        getClockList(this.rowInfo.id).then((res) => {
            if(res.data.code==0) {
                this.clockInfos = res.data.data;
                setTimeout(function() {
                    that.getMyLocation();
                },1000)
            }
        })
    },

    /**
     * 绘制地点
     */
    async getMyLocation() {
      if(this.map) {
        console.log(this.map);
        return;
      }
      // 按顺序整合所有点信息
      this.getAllPaths();
      // 设置中心点，以起点为中心点
      this.center = this.createLatLng(this.rowInfo.startPointLatitude, this.rowInfo.startPointLongitude);
      // 初始化地图
      this.map = new TMap.Map('mapContainer', {
        center: this.center,
        zoom: 15
      });
      // 绘制地图折现
      this.drawMap();
      // 设置打卡点样式
      this.handleGenometries();
      // 设置路线途径点样式
      this.handlePointStyle();
    },

    /**
     * 按顺序整合所有点信息
     * 打卡点和途径点只能渲染一种，否则会导致点连线错乱，途径点没有时间排序
     */
    getAllPaths() {
      // 起始点
      this.paths.push(this.createLatLng(this.rowInfo.startPointLatitude, this.rowInfo.startPointLongitude));
      // 途径点
      const passingPlaceList = this.passingPlaces;
      // 打卡点
      const clockList = this.clockInfos;
      if (clockList && clockList.length > 0) {
        // 打卡点
        for (let i = 0; i < clockList.length; i++) {
          this.paths.push(this.createLatLng(clockList[i].pointLatitude, clockList[i].pointLongitude));
        }
      } else if(passingPlaceList && passingPlaceList.length > 0){
        // 途径点
        for (let i = 0; i < passingPlaceList.length; i++) {
            this.paths.push(this.createLatLng(passingPlaceList[i].pointLatitude, passingPlaceList[i].pointLongitude));
        }
      }
      // 终点
      this.paths.push(this.createLatLng(this.rowInfo.endPointLatitude, this.rowInfo.endPointLongitude));
    },

    /**
     * 绘制地图
     */
    drawMap() {
      var polylineLayer = new TMap.MultiPolyline({
        // 绘制到目标地图
        map: this.map,
        // 折线样式定义
        styles: {
          'style_blue': new TMap.PolylineStyle({
            'color': '#3777FF', //线填充色
            'width': 4, //折线宽度
            'borderWidth': 2, //边线宽度
            'borderColor': '#FFF', //边线颜色
            'lineCap': 'round' //线端头方式
          })
        },
        geometries: [{
          styleId: 'style_blue',
          paths: this.paths
        }],
      });
    },

    /**
     * 设置打卡点样式
     */
    handleGenometries() {
      // 设置固定点样式
      this.setRegularGenometries();
      // 设置非固定点样式
      this.setDynamicGenometries();
    },

    /**
     * 设置固定点样式：小车、起点、终点
     */
    setRegularGenometries() {
      // // 小车
      // this.geometries.push({
      //     "id": this.pointFlag.car,
      //     "styleId": 'car-down',
      //     "position": this.createLatLng(this.rowInfo.startPointLatitude, this.rowInfo.startPointLongitude),
      // });
      // 起点
      this.geometries.push({
          "id": this.pointFlag.start,
          "styleId": 'start',
          "position": this.createLatLng(this.rowInfo.startPointLatitude, this.rowInfo.startPointLongitude)
      });
      // 终点
      this.geometries.push({
          "id": this.pointFlag.end,
          "styleId": 'end',
          "position": this.createLatLng(this.rowInfo.endPointLatitude, this.rowInfo.endPointLongitude)
        });
    },

    /**
     * 设置非固定点样式：途径点/员工打卡点、司机打卡点
     */
    setDynamicGenometries() {
      // 途径点
      const passingPlaceList = this.rowInfo.passingPlaceList;
      // 打卡点
      const clockList = this.clockInfos;
      if (clockList && clockList.length > 0) {
        // 打卡点
        for (let i = 0; i < clockList.length; i++) {
          const clockInfo = clockList[i];
          if(clockInfo.type == this.clockType.EMP) {
           // 员工打卡
           this.geometries.push({
              "id": this.pointFlag.clock+ "-"+ i,
              "styleId": 'empClock',
              "position": this.createLatLng(clockInfo.pointLatitude, clockInfo.pointLongitude)
            });
          } else if(clockInfo.type == this.clockType.DRIVER) {
            // 司机打卡
            this.geometries.push({
              "id": this.pointFlag.clock+ "-"+ i,
              "styleId": 'driverClock',
              "position": this.createLatLng(clockInfo.pointLatitude, clockInfo.pointLongitude)
            });
          }
        }
      } else if(passingPlaceList && passingPlaceList.length > 0){
        // 途径点
        for (let i = 0; i < passingPlaceList.length; i++) {
          // passingPlace
          const passingPlace = passingPlaceList[i];
          // 途径点
          this.geometries.push({
              "id": this.pointFlag.pass+ "-"+ i,
              "styleId": 'passingPlace',
              "position": this.createLatLng(passingPlaceList[i].pointLatitude, passingPlaceList[i].pointLongitude)
            });
        }
      }
    },

    /**
     * 设置路线途径点样式
     */
    handlePointStyle() {
       this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: this.pointStyles,
        geometries: this.geometries,
      });

      // TODO 初始化点击事件
      this.initClickEvent();
      // 小车移动事件
      // this.carMoveEvent();
    },

    /**
     * 初始化点击事件
     */
    initClickEvent() {
      //初始化infoWindow
      const infoWindow = new TMap.InfoWindow({
          map: this.map,
          position: new TMap.LatLng(this.rowInfo.startPointLatitude, this.rowInfo.startPointLongitude),
          offset: { x: 0, y: -32 } //设置信息窗相对position偏移像素
      });
      infoWindow.close();//初始关闭信息窗关闭

      let that = this;
      this.marker.on("click", function (evt) {
        // 处理点击事件
        let geometryId = evt.geometry.id;
        let idArray = geometryId.split("-");
        if(idArray.length == 1) {
          // 起点或终点
          let pointTag = idArray[0];
          if(pointTag == that.pointFlag.start) {
            // 起点
            let attachUrls = [that.rowInfo.startMileageAttachUrl];
            let tips = that.appendTips(`行程起点:${that.rowInfo.startPointName}`, null, attachUrls);
            that.openInfoWindow(infoWindow, evt.geometry.position,tips);
          } else if(pointTag == that.pointFlag.end) {
            // 终点
            let attachUrls = [that.rowInfo.endMileageAttachUrl]
            let tips = that.appendTips(`行程终点:${that.rowInfo.endPointName}`, null, attachUrls);
            that.openInfoWindow(infoWindow, evt.geometry.position,tips);
          }
        } else if(idArray.length == 2) {
          // 打卡点/途径点添加点击事件
          let pointTag = idArray[0];
          let ponitIndex = idArray[1];
          if(pointTag == that.pointFlag.clock) {
            // 打卡点
            const clickPointInfo = that.clockInfos[ponitIndex];
            let tips = that.appendTips(`行程第${parseInt(ponitIndex, 10) + 1}个打卡点:${clickPointInfo.pointName}`, `打卡时间:${clickPointInfo.clockTime}`, clickPointInfo.attachUrls);
            that.openInfoWindow(infoWindow, evt.geometry.position,tips);
          } else if(pointTag == that.pointFlag.pass) {
            // 途径点
            const passPointInfo = that.passingPlaces[ponitIndex];
            let tips = that.appendTips(`行程第${parseInt(ponitIndex, 10) + 1}个途径点:${passPointInfo.pointName}`, null, null)
            that.openInfoWindow(infoWindow, evt.geometry.position,tips);
          }
        }
      })
    },

    /**
     * 拼接信息窗内容
     */
    appendTips(pointNameTxt, clockTimeTxt, attachUrls) {
      // 名称
      let tips = `<div style="text-align:center;white-space:nowrap;margin:10px;">${pointNameTxt}`;
      if(clockTimeTxt != null && clockTimeTxt != '') {
        // 时间
        tips += `<br>${clockTimeTxt}`;
      }
      if(attachUrls != null && attachUrls.length > 0) {
        tips += `<br>`
        attachUrls.forEach((item,index) => {
          // 附件打开路径 
          tips += `<div><a href="/api/${item}" target="_blank" style="color: blue;">附件${index + 1}</a>`
        });
        tips += `</div>`
      }
      tips += '</div>';
      return tips;
    },

    /**
     * 点击打开弹窗
     * 
     * @param infoWindow 
     * @param position  evt.geometry.position
     * @param tips      提示信息
     */
    openInfoWindow(infoWindow,position, tips) {
      //打开信息窗
      infoWindow.open(); 
      //设置信息窗位置
      infoWindow.setPosition(position);
      //设置信息窗内容
      infoWindow.setContent(tips);
    },

    /**
     * 小车移动事件
     * 
     */
    carMoveEvent() {
      this.marker.moveAlong({
        'car': {
          path: this.paths,
          speed: 500 
        }
      }, {
        autoRotation: true
      })
    },

    /**
     * 辅助函数
     * 
     * @param latitude 
     * @param longitude 
     */
    createLatLng(latitude, longitude) {
        return new TMap.LatLng(latitude, longitude);
    },

    /**
     * 关闭Dialog
     */
    closeForm() {
      this.visible = false;
      this.rowInfo = {};
    },
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .popup {
    position: absolute;
    background-color: white;
    padding: 10px;
    border: 1px solid #ccc;
    z-index: 1000;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
</style>
